import React, { useCallback, useEffect, useState } from 'react';
//import '@ant-design/compatible/assets/index.css';
import moment from 'moment';
import { Form, Col, DatePicker, Input, Row, Card } from 'antd';
import { isEmpty } from 'lodash';
import DF from 'DisplayFramework';
import AssetsTable from './AssetsTable';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import { getFinContractById } from 'services/fincontract';

const TabAssetDelivery = (props: any) => {
  
  const { setSuccessful, form, objectid } = props;

  form.setFieldsValue({
    event: 'tabAssetDelivery',
  });

  const [state, setState] = useState<any>({
    isLoading: false,
    selectedRowKeys: [],
    ASSETLIST: [],
    startdate: moment(),
    currcode: localStorage.getItem('currcode') ?? '',
  });

  const initValues = useCallback(() => {
    form.setFieldsValue({
      deliveryReference: '',
      deliveryDate: moment(),
      effectDate: moment(),
    });
  }, [form]);

  const updateState = useCallback(
    (values) => {
      setState((prev: any) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const loadCTDetail = useCallback(
    (ctrid) => {
      setSuccessful(true);

      getFinContractById({ ctrid }).then((response) => {

        const contract = response.data;

        updateState({
          ASSETLIST: contract.assets.map((asset: any) => ({
            ...asset,
          })),
        });

        initValues();
      });
    },
    [initValues, form,updateState]
  );

  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      let listAsset = '';
      for (const i in selectedRows) {
        listAsset = selectedRows[i].assetid + `,` + listAsset;
      }

      form.setFieldsValue({
        listAsset: listAsset ?? [],
      });
      setSuccessful(selectedRowKeys?.length > 0 ? false : true);

    },
  };

  useEffect(() => {
    loadCTDetail(objectid);
  }, [objectid]);


  return (
    <DF.Provider pagcode="tabAssetDelivery">
      <Form form={form}>
        <Form.Item shouldUpdate noStyle>
          <Card title={<GetLabel label="Assets" />}>
            <Row gutter={16}>
              <Col span={24}>
                <Row gutter={16}>
                
                  <Col span={6}>
                    <FormInput
                      style={{ margin: 0 }}
                      name="effectDate"
                      comcode="effectDate"
                    >
                      <DatePicker showToday />
                    </FormInput>
                  </Col>
                  <Col span={6}>
                    <FormInput
                      style={{ margin: 0 }}
                      name="deliveryDate"
                      comcode="deliveryDate"
                    >
                      <DatePicker showToday />
                    </FormInput>
                  </Col>
                  <Col span={10}>
                    <FormInput
                      col
                      xs={12}
                      name="deliveryReference"
                      comcode="deliveryReference"
                      rules={[{ required: true }]}
                    />
                  </Col>
                </Row>
                <FormInput
                  style={{ margin: 0 }}
                  name="listAsset"
                  rules={[
                    {
                      validator() {
                        if (isEmpty(state.selectedRowKeys)) {
                          return Promise.reject(new Error('No Asset Selected'));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                  col
                  xs={24}
                  comcode="listAsset"
                >
                  <Input value={state.selectedRowKeys} hidden />
                </FormInput>
                <AssetsTable
                  currcode={state.currcode}
                  isLoading={state.isLoading}
                  size="small"
                  scroll={{ x: 1000, y: 250 }}
                  pagination={{ pageSize: 100 }}
                  rowSelection={{
                    type: 'checkbox',
                    ...rowSelection,
                  }}
                  dataSource={state.ASSETLIST}
                  rowKey={(record) => record.assetid}
                />
              </Col>
            </Row>
          </Card>
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};
export default TabAssetDelivery;
